import { render, staticRenderFns } from "./OverviewSectionV2.vue?vue&type=template&id=c30dfa2e&scoped=true&"
import script from "./OverviewSectionV2.vue?vue&type=script&lang=js&"
export * from "./OverviewSectionV2.vue?vue&type=script&lang=js&"
import style0 from "./OverviewSectionV2.vue?vue&type=style&index=0&id=c30dfa2e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c30dfa2e",
  null
  
)

export default component.exports